<template>
  <div class="w-full font-sans bg-white py-10">
    <div
      v-if="!isMobile"
      class="max-w-6xl mx-auto px-4 grid grid-cols-10 gap-8"
    >
      <div class="col-span-10 order-2">
        <div class="flex space-x-3 overflow-x-auto py-2">
          <div
            v-for="(thumb, index) in carousel"
            :key="index"
            class="flex-shrink-0 w-20 h-20 border-2 rounded-lg p-1 cursor-pointer transition-colors"
            :class="{
              'border-black shadow-md': index === activeIndex,
              'border-gray-200 hover:border-gray-400': index !== activeIndex,
            }"
            @click="activeIndex = index"
          >
            <img
              :src="thumb"
              alt="Thumbnail"
              class="w-full h-full object-cover rounded-md"
            />
          </div>
        </div>
      </div>

      <div class="col-span-10 order-1 relative">
        <div
          class="relative w-full aspect-square bg-gray-100 rounded-lg overflow-hidden"
        >
          <img
            :src="currentImageUrl"
            alt="Main Product Image"
            class="w-full h-full object-cover transition-opacity duration-300"
            @mousemove="handleMouseMove"
            @mouseenter="isZoomed = true"
            @mouseleave="isZoomed = false"
          />

          <div class="absolute inset-0 pointer-events-none">
            <div
              class="absolute inset-0 bg-gradient-to-r from-transparent to-black/20"
            ></div>
            <div
              class="absolute left-0 bottom-0 p-2 bg-black/50 text-white text-xs"
            >
              W80
            </div>
            <div
              class="absolute right-0 bottom-0 p-2 bg-black/50 text-white text-xs"
            >
              Others
            </div>

            <div
              class="absolute left-4 -bottom-20 flex items-center space-x-4 text-gray-700"
            >
              <span class="text-4xl">💡</span>
              <span class="text-6xl font-extrabold text-gray-200 drop-shadow-lg"
                >50000</span
              >
              <span class="text-xl">♻️ Hours</span>
            </div>
          </div>
        </div>

        <div
          v-show="isZoomed"
          class="absolute left-[105%] top-0 w-[400px] h-[400px] bg-white border border-gray-300 shadow-xl rounded-lg overflow-hidden z-20"
        >
          <img
            :src="currentImageUrl"
            alt="Zoomed Product Image"
            :style="magnifierStyle"
            class="absolute transform-gpu"
          />
        </div>
      </div>
    </div>

    <div v-else class="w-full px-0 md:px-4">
      <MobileCarousel :images="allImages" />
    </div>
  </div>
</template>

<script>
// 导入新的 MobileCarousel 组件
import MobileCarousel from "./MobileCarousel.vue";

export default {
  name: "ProductImageGallery",
  components: {
    MobileCarousel, // 注册新的组件
  },
  props: {
    carousel: {
      type: Array,
      default: () => [],
    },
    // 可以通过 props 传入初始图片数据（如果需要）
  },
  data() {
    return {
      isMobile: false,
      activeIndex: 0,
      isZoomed: false, // 放大镜状态
      mousePosX: 0, // 鼠标 X 坐标
      mousePosY: 0, // 鼠标 Y 坐标
      zoomFactor: 2.5, // 放大倍数
    };
  },
  computed: {
    // 获取当前选中的图片 URL
    currentImageUrl() {
      return this.carousel.length > 0 ? this.carousel[this.activeIndex] : "";
    },
    // 移动端轮播图使用所有图片
    allImages() {
      return this.carousel.map((thumb, index) => ({
        url: thumb,
        label: `Image ${index + 1}`,
      }));
    },
    // 放大镜视图的 CSS 样式
    magnifierStyle() {
      // 确保图片尺寸被放大
      const width = 400 * this.zoomFactor;
      const height = 400 * this.zoomFactor;

      // 计算图片在放大镜容器中的偏移量
      // 鼠标位于主图的 (mousePosX, mousePosY) 处，
      // 放大镜窗口需要显示该点的放大版本，因此需要将图片向反方向偏移
      const offsetX = -this.mousePosX * this.zoomFactor + 400 / 2; // 400 是放大镜窗口的尺寸
      const offsetY = -this.mousePosY * this.zoomFactor + 400 / 2;

      return {
        width: `${width}px`,
        height: `${height}px`,
        transform: `translate(${offsetX}px, ${offsetY}px)`,
        cursor: "none",
        objectFit: "cover",
      };
    },
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth <= 990;
    },
    handleMouseMove(event) {
      // 仅在放大镜激活时处理
      if (!this.isZoomed) return;

      // 获取主图容器的 DOM 元素
      const container = event.currentTarget.getBoundingClientRect();

      // 计算鼠标在主图上的相对坐标 (0 到 1)
      let x = (event.clientX - container.left) / container.width;
      let y = (event.clientY - container.top) / container.height;

      // 转换为像素坐标 (基于 400x400 的主图容器尺寸)
      this.mousePosX = x * 400;
      this.mousePosY = y * 400;
    },
  },
};
</script>

<style scoped>
/* 移动端轮播图的样式在 MobileCarousel.vue 中定义 */
</style>
